module.exports = __webpack_public_path__ + "img/vue.6f50bccf.jpg";